import { Navigate, useLocation } from "react-router-dom";
import { useSiteSettings } from "../contexts/SiteSettingsContext";

const RouteGuard = ({ children }) => {
    const { isComingSoon, loading } = useSiteSettings();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-4 border-green-200 border-t-[#008000]"></div>
            </div>
        );
    }

    if (isComingSoon) {
        const allowedRoutes = ["/", "/signin", "/signup"];
        const isAllowedRoute = allowedRoutes.includes(location.pathname) ||
            location.pathname.startsWith("/admin") ||
            location.pathname.startsWith("/reset-password");

        if (isAllowedRoute) {
            return children;
        }

        return <Navigate to="/" replace />;
    }

    return children;
};

export default RouteGuard;

